import React from "react";
import Input from "@ui/inputs";

const StandardInput = (props) => {
    const {
        id,
        name,
        label,
        placeholder,
        readOnly,
        value,
        maxLength,
        minLength,
        onChange,
        onBlur,
        onKeyPress,
        onKeyDown,
        errorToDisplay,
        inputMode,
        note,
        tooltip,
        prefixSign,
        options,
        autoFocus,
        type,
    } = props;

    return (
        <Input
            className="py-4"
            id={id}
            type={type}
            prefixSign={prefixSign}
            name={name}
            label={label}
            placeholder={placeholder}
            value={value}
            note={note}
            tooltip={tooltip}
            onChange={readOnly ? null : onChange}
            onBlur={readOnly ? null : onBlur}
            error={readOnly ? null : errorToDisplay}
            maxLength={maxLength > 0 ? maxLength : null}
            minLength={minLength > 0 ? minLength : null}
            readOnly={readOnly}
            inputMode={inputMode}
            onKeyPress={readOnly ? null : onKeyPress}
            onKeyDown={readOnly ? null : onKeyDown}
            options={options}
            autoFocus={autoFocus}
        />
    );
};

export default StandardInput;
